import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  className?: string;
}
export function CTAButton({
  text,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    document.getElementById('contact-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <motion.button onClick={handleClick} className={`
        inline-flex items-center justify-center
        bg-gold text-carbon font-bold text-lg md:text-xl
        px-8 py-4 rounded-md
        transition-all duration-300
        hover:bg-yellow-400 hover:scale-[1.02]
        active:scale-[0.98]
        animate-pulse-gold
        w-full md:w-auto
        ${className}
      `} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-104">
      {text}
      <ArrowRight className="ml-2 w-6 h-6" data-id="element-105" />
    </motion.button>;
}